import { loadState, saveState } from './localStore';
import { USER_KEY } from '../constants';
export function getAuthenticatedUser() {
  return loadState(USER_KEY) || null;
}
export function saveAuthenticatedUser(user) {
  saveState(USER_KEY, user);
}